/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getAnalytics(params = {}) {
    return axios.get(`${this.url}/analytics`, { params });
  }

  showAnalytics(id, params = {}) {
    return axios.get(`${this.url}/${id}/analytics`, { params });
  }
}

export default new CampaignsAPI();
